// extracted by mini-css-extract-plugin
export default {"carouselWrapper":"ImageRotator_carouselWrapper__GfapG","carouselContainer":"ImageRotator_carouselContainer__4105H","imageItem":"ImageRotator_imageItem__dAIz4"};